import { useState } from "react";
import { Link } from "react-router";

import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import MUIDataTable from "mui-datatables";

import BackdropLoader from "../../../components/BackdropLoader";
import TableSkeleton from "../../../components/skeletons/TableSkeleton";

import { getColumns, getOptions } from "./config";

import { useTranslation } from "react-i18next";
import { useGetCompaniesQuery } from "../companiesApiSlice";

const List = () => {
	const { t } = useTranslation();
	const [selectValue, setSelectValue] = useState("");
	const [statusFilterValue, setStatusFilterValue] = useState(
		"accepted,active,testing,blocked,invoice_blocked"
	);
	const [sourceFilterValue, setSourceFilterValue] =
		useState("contact,register");

	const { data, error, isLoading, isFetching } = useGetCompaniesQuery({
		status: statusFilterValue,
		source: sourceFilterValue,
	});

	const handleStatusChange = (e) => {
		const newValue = e.target.value;
		let statusValue = statusFilterValue;
		let sourceValue = sourceFilterValue;

		if (newValue === "all") {
			statusValue = "accepted,active,testing,blocked,invoice_blocked";
			sourceValue = "contact,register";
		}

		if (newValue === "contact" || newValue === "register") {
			statusValue = "accepted,active,testing,blocked,invoice_blocked";
			sourceValue = newValue;
		}

		if (
			newValue !== "contact" &&
			newValue !== "register" &&
			newValue !== "all"
		) {
			statusValue = newValue;
			sourceValue = "contact,register";
		}

		setStatusFilterValue(statusValue);
		setSourceFilterValue(sourceValue);
		setSelectValue(newValue);
	};

	if (isLoading) {
		return (
			<Box sx={{ mt: "64px" }}>
				<TableSkeleton />
			</Box>
		);
	}

	const columns = getColumns(t);
	const options = getOptions(t);

	return (
		<>
			<Box sx={{ position: "relative" }}>
				<Box
					sx={{
						position: "absolute",
						right: "0",
						top: "15px",
						zIndex: "100",
						display: "flex",
						alignItems: "center",
						gap: "22px",
						width: "320px",
					}}
				>
					<FormControl fullWidth margin="none">
						<Select
							labelId="status-select"
							onChange={handleStatusChange}
							value={selectValue}
							size="small"
							displayEmpty
						>
							<MenuItem value="">{t("company_status_all")}</MenuItem>
							<MenuItem value="active">{t("company_status_active")}</MenuItem>
							<MenuItem value="blocked">{t("company_status_blocked")}</MenuItem>
							<MenuItem value="invoice_blocked">
								{t("company_status_invoice_blocked")}
							</MenuItem>
							<MenuItem value="testing">{t("company_status_testing")}</MenuItem>
							<MenuItem value="contact">{t("company_status_contact")}</MenuItem>
							<MenuItem value="register">
								{t("company_status_register")}
							</MenuItem>
						</Select>
					</FormControl>
					<Link
						to="/admin/company/add"
						target="_blank"
						rel="noopener noreferrer"
						style={{
							whiteSpace: "nowrap",
							border: "1px solid #BDE3FF",
							color: "#000",
							textDecoration: "none",
							padding: "7px 22px",
						}}
					>
						{t("add_company")}
					</Link>
				</Box>
				<MUIDataTable
					className="mui-data-table companies-table center-all-cells"
					data={data.companies}
					columns={columns}
					options={options}
				/>
			</Box>
			<BackdropLoader isOpen={isFetching} />
		</>
	);
};

export default List;
